import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';

@Component({
    standalone: false,
    selector: 'broker-search-dialog',
    templateUrl: './broker-search-dialog.component.html',
    providers: [DataService]
})
export class BrokerSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Broker';
        this.model.title = 'Select Broker';

        this.model.criteria.Max = this.model.currentOptions.maxRows;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
